import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(auth)/auth.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LanguageSelector/LanguageSelector.tsx");
